// // // // src/components/OrderList/useOrdersManager.js

// // // import { useEffect, useMemo, useState } from "react";
// // // import {
// // //   collection,
// // //   getDocs,
// // //   doc,
// // //   updateDoc,
// // //   serverTimestamp,
// // // } from "firebase/firestore";
// // // import { db } from "../../../firebase";

// // // import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
// // // import {
// // //   parseChoice,
// // //   getStatus,
// // //   getTtn,
// // //   ts,
// // //   dayStart,
// // //   dayEnd,
// // // } from "./orderUtils";

// // // export function useOrdersManager(initialPageSize = 10) {
// // //   const [orders, setOrders] = useState([]); // [{ order, choice }]
// // //   const [expanded, setExpanded] = useState({});

// // //   // status edit
// // //   const [editingStatusId, setEditingStatusId] = useState(null);
// // //   const [statusDraft, setStatusDraft] = useState("");

// // //   // ttn edit
// // //   const [editingTtnId, setEditingTtnId] = useState(null);
// // //   const [ttnDraft, setTtnDraft] = useState("");

// // //   // filters/sort
// // //   const [sortDir, setSortDir] = useState("desc");
// // //   const [statusPin, setStatusPin] = useState("Усі");
// // //   const [statusOnly, setStatusOnly] = useState(false);
// // //   const [dateFrom, setDateFrom] = useState("");
// // //   const [dateTo, setDateTo] = useState("");

// // //   // paging
// // //   const [page, setPage] = useState(1);
// // //   const [pageSize, setPageSize] = useState(initialPageSize);

// // //   useEffect(() => {
// // //     (async () => {
// // //       try {
// // //         const snap = await getDocs(collection(db, "orders"));
// // //         const rows = [];
// // //         snap.forEach((d) => {
// // //           const raw = { id: d.id, ...d.data() };
// // //           rows.push({ order: raw, choice: parseChoice(raw?.choice) });
// // //         });
// // //         setOrders(rows);
// // //       } catch (e) {
// // //         console.error("OrderList load error:", e);
// // //         setOrders([]);
// // //       }
// // //     })();
// // //   }, []);

// // //   useEffect(() => {
// // //     setPage(1);
// // //   }, [
// // //     pageSize,
// // //     sortDir,
// // //     statusPin,
// // //     statusOnly,
// // //     dateFrom,
// // //     dateTo,
// // //     orders.length,
// // //   ]);

// // //   const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

// // //   const filtered = useMemo(() => {
// // //     let arr = [...orders];

// // //     if (statusOnly && statusPin !== "Усі") {
// // //       arr = arr.filter(({ order }) => getStatus(order) === statusPin);
// // //     }

// // //     if (dateFrom || dateTo) {
// // //       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
// // //       const toMs = dateTo ? dayEnd(dateTo) : Infinity;
// // //       arr = arr.filter(({ order }) => {
// // //         const t = ts(order);
// // //         return t >= fromMs && t <= toMs;
// // //       });
// // //     }

// // //     return arr;
// // //   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

// // //   const sorted = useMemo(() => {
// // //     const arr = [...filtered];

// // //     const cmpDate = (a, b) => {
// // //       const A = ts(a.order);
// // //       const B = ts(b.order);
// // //       return sortDir === "asc" ? A - B : B - A;
// // //     };

// // //     if (statusPin !== "Усі" && !statusOnly) {
// // //       arr.sort((a, b) => {
// // //         const pa = getStatus(a.order) === statusPin ? 0 : 1;
// // //         const pb = getStatus(b.order) === statusPin ? 0 : 1;
// // //         if (pa !== pb) return pa - pb;
// // //         return cmpDate(a, b);
// // //       });
// // //     } else {
// // //       arr.sort(cmpDate);
// // //     }

// // //     return arr;
// // //   }, [filtered, sortDir, statusPin, statusOnly]);

// // //   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
// // //   const pageClamped = Math.min(page, totalPages);
// // //   const start = (pageClamped - 1) * pageSize;
// // //   const end = start + pageSize;
// // //   const paged = sorted.slice(start, end);

// // //   const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

// // //   // ===== STATUS =====
// // //   const beginEditStatus = (order, e) => {
// // //     e?.stopPropagation?.();
// // //     setEditingStatusId(order.id);
// // //     setStatusDraft(getStatus(order));
// // //   };

// // //   const cancelEditStatus = () => {
// // //     setEditingStatusId(null);
// // //     setStatusDraft("");
// // //   };

// // //   const saveStatusToDb = async (orderId, nextStatusRaw) => {
// // //     const nextStatus =
// // //       String(nextStatusRaw || "").trim() || "Очікує підтвердження";

// // //     const row = orders.find((r) => r.order.id === orderId);
// // //     const currentOrder = row?.order || {};
// // //     const currentTtn = getTtn(currentOrder);

// // //     if (
// // //       TTN_REQUIRED_STATUSES.has(nextStatus) &&
// // //       !String(currentTtn || "").trim()
// // //     ) {
// // //       alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
// // //       return;
// // //     }

// // //     const canceled = nextStatus === "Скасовано";
// // //     const nowISO = new Date().toISOString();

// // //     await updateDoc(doc(db, "orders", orderId), {
// // //       status: nextStatus,
// // //       canceled,
// // //       updatedAt: serverTimestamp(),
// // //       updatedAtISO: nowISO,
// // //       statusFlow: { current: nextStatus, updatedAtISO: nowISO },
// // //     });

// // //     setOrders((arr) =>
// // //       arr.map((r) =>
// // //         r.order.id === orderId
// // //           ? {
// // //               ...r,
// // //               order: {
// // //                 ...r.order,
// // //                 status: nextStatus,
// // //                 canceled,
// // //                 updatedAtISO: nowISO,
// // //                 statusFlow: {
// // //                   ...(r.order?.statusFlow || {}),
// // //                   current: nextStatus,
// // //                   updatedAtISO: nowISO,
// // //                 },
// // //               },
// // //             }
// // //           : r,
// // //       ),
// // //     );
// // //   };

// // //   const saveStatus = async (orderId) => {
// // //     await saveStatusToDb(orderId, statusDraft);
// // //     cancelEditStatus();
// // //   };

// // //   const onStatusKey = (e, orderId) => {
// // //     if (e.key === "Enter") saveStatus(orderId);
// // //     if (e.key === "Escape") cancelEditStatus();
// // //   };

// // //   // ===== TTN =====
// // //   const beginEditTTN = (order) => {
// // //     setEditingTtnId(order.id);
// // //     setTtnDraft(String(getTtn(order) || ""));
// // //   };

// // //   const cancelEditTTN = () => {
// // //     setEditingTtnId(null);
// // //     setTtnDraft("");
// // //   };

// // //   const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
// // //     const normalized = String(ttnValue || "")
// // //       .replace(/\D/g, "")
// // //       .trim();
// // //     if (!/^\d{8,14}$/.test(normalized)) {
// // //       alert("Введіть коректний номер ТТН (8–14 цифр).");
// // //       return;
// // //     }

// // //     const row = orders.find((r) => r.order.id === orderId);
// // //     const currentOrder = row?.order || {};
// // //     const currentStatus = getStatus(currentOrder);
// // //     const nextStatus = options.setStatusAfterSave
// // //       ? "ТТН НП внесено"
// // //       : currentStatus;

// // //     const nowISO = new Date().toISOString();

// // //     await updateDoc(doc(db, "orders", orderId), {
// // //       ttn: normalized,
// // //       status: nextStatus,
// // //       updatedAt: serverTimestamp(),
// // //       updatedAtISO: nowISO,
// // //       delivery: { ...(currentOrder?.delivery || {}), ttn: normalized },
// // //       logistics: {
// // //         ...(currentOrder?.logistics || {}),
// // //         provider: "Нова пошта",
// // //         providerLabel: "Нова пошта",
// // //         ttn: normalized,
// // //         updatedAtISO: nowISO,
// // //       },
// // //     });

// // //     setOrders((arr) =>
// // //       arr.map((r) => {
// // //         if (r.order.id !== orderId) return r;
// // //         return {
// // //           ...r,
// // //           order: {
// // //             ...r.order,
// // //             ttn: normalized,
// // //             status: nextStatus,
// // //             updatedAtISO: nowISO,
// // //             delivery: { ...(r.order?.delivery || {}), ttn: normalized },
// // //             logistics: {
// // //               ...(r.order?.logistics || {}),
// // //               provider: "Нова пошта",
// // //               providerLabel: "Нова пошта",
// // //               ttn: normalized,
// // //               updatedAtISO: nowISO,
// // //             },
// // //           },
// // //         };
// // //       }),
// // //     );
// // //   };

// // //   const saveTTN = async (orderId) => {
// // //     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
// // //     cancelEditTTN();
// // //   };

// // //   const saveTTNAndSetStatus = async (orderId) => {
// // //     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
// // //     cancelEditTTN();
// // //   };

// // //   const onTtnKey = (e, orderId) => {
// // //     if (e.key === "Enter") saveTTN(orderId);
// // //     if (e.key === "Escape") cancelEditTTN();
// // //   };

// // //   return {
// // //     orders,
// // //     paged,
// // //     expanded,
// // //     toggleExpand,

// // //     // filters
// // //     sortDir,
// // //     setSortDir,
// // //     statusPin,
// // //     setStatusPin,
// // //     statusOnly,
// // //     setStatusOnly,
// // //     dateFrom,
// // //     setDateFrom,
// // //     dateTo,
// // //     setDateTo,

// // //     // paging
// // //     pageSize,
// // //     setPageSize,
// // //     totalPages,
// // //     pageClamped,
// // //     goto,

// // //     // status
// // //     editingStatusId,
// // //     statusDraft,
// // //     setStatusDraft,
// // //     beginEditStatus,
// // //     saveStatus,
// // //     cancelEditStatus,
// // //     onStatusKey,

// // //     // ttn
// // //     editingTtnId,
// // //     ttnDraft,
// // //     setTtnDraft,
// // //     beginEditTTN,
// // //     saveTTN,
// // //     saveTTNAndSetStatus,
// // //     cancelEditTTN,
// // //     onTtnKey,

// // //     STATUS_OPTIONS,
// // //   };
// // // }
// // // src/components/OrderList/useOrdersManager.js

// // import { useEffect, useMemo, useState } from "react";
// // import {
// //   collection,
// //   getDocs,
// //   getDoc,
// //   doc,
// //   updateDoc,
// //   serverTimestamp,
// // } from "firebase/firestore";
// // import { db } from "../../../firebase";

// // import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
// // import {
// //   parseChoice,
// //   getStatus,
// //   getTtn,
// //   ts,
// //   dayStart,
// //   dayEnd,
// //   getItemFinalUnitPrice,
// // } from "./orderUtils";

// // export function useOrdersManager(initialPageSize = 10) {
// //   const [orders, setOrders] = useState([]); // [{ order, choice }]
// //   const [expanded, setExpanded] = useState({});

// //   // status edit
// //   const [editingStatusId, setEditingStatusId] = useState(null);
// //   const [statusDraft, setStatusDraft] = useState("");

// //   // ttn edit
// //   const [editingTtnId, setEditingTtnId] = useState(null);
// //   const [ttnDraft, setTtnDraft] = useState("");
// //   // ===== ITEMS EDIT =====
// //   const [editingItemsId, setEditingItemsId] = useState(null);
// //   const [itemsDraft, setItemsDraft] = useState([]);
// //   const [newPid, setNewPid] = useState("");
// //   const [newQty, setNewQty] = useState(1);
// //   const [savingItems, setSavingItems] = useState(false);
// //   // filters/sort
// //   const [sortDir, setSortDir] = useState("desc");
// //   const [statusPin, setStatusPin] = useState("Усі");
// //   const [statusOnly, setStatusOnly] = useState(false);
// //   const [dateFrom, setDateFrom] = useState("");
// //   const [dateTo, setDateTo] = useState("");

// //   // paging
// //   const [page, setPage] = useState(1);
// //   const [pageSize, setPageSize] = useState(initialPageSize);
// //   const buildRow = (docSnapOrId, dataMaybe) => {
// //     // варіант 1: коли передаємо snap (getDoc)
// //     if (docSnapOrId?.exists && docSnapOrId.exists()) {
// //       const raw = { id: docSnapOrId.id, ...docSnapOrId.data() };
// //       return { order: raw, choice: parseChoice(raw?.choice) };
// //     }

// //     // варіант 2: коли передаємо id+data
// //     const id = String(docSnapOrId || "");
// //     const raw = { id, ...(dataMaybe || {}) };
// //     return { order: raw, choice: parseChoice(raw?.choice) };
// //   };
// //   const loadOrders = async () => {
// //     const snap = await getDocs(collection(db, "orders"));
// //     const rows = [];
// //     snap.forEach((d) => {
// //       rows.push(buildRow(d));
// //     });
// //     setOrders(rows);
// //   };
// //   const reloadOneOrder = async (orderId) => {
// //     const ref = doc(db, "orders", String(orderId));
// //     const snap = await getDoc(ref);

// //     if (!snap.exists()) return;

// //     const updatedRow = buildRow(snap);

// //     setOrders((arr) =>
// //       arr.map((r) => (r.order.id === orderId ? updatedRow : r)),
// //     );
// //   };
// //   useEffect(() => {
// //     (async () => {
// //       try {
// //         await loadOrders();
// //       } catch (e) {
// //         console.error("OrderList load error:", e);
// //         setOrders([]);
// //       }
// //     })();
// //   }, []);

// //   useEffect(() => {
// //     setPage(1);
// //   }, [
// //     pageSize,
// //     sortDir,
// //     statusPin,
// //     statusOnly,
// //     dateFrom,
// //     dateTo,
// //     orders.length,
// //   ]);

// //   const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

// //   const filtered = useMemo(() => {
// //     let arr = [...orders];

// //     if (statusOnly && statusPin !== "Усі") {
// //       arr = arr.filter(({ order }) => getStatus(order) === statusPin);
// //     }

// //     if (dateFrom || dateTo) {
// //       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
// //       const toMs = dateTo ? dayEnd(dateTo) : Infinity;
// //       arr = arr.filter(({ order }) => {
// //         const t = ts(order);
// //         return t >= fromMs && t <= toMs;
// //       });
// //     }

// //     return arr;
// //   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

// //   const sorted = useMemo(() => {
// //     const arr = [...filtered];

// //     const cmpDate = (a, b) => {
// //       const A = ts(a.order);
// //       const B = ts(b.order);
// //       return sortDir === "asc" ? A - B : B - A;
// //     };

// //     if (statusPin !== "Усі" && !statusOnly) {
// //       arr.sort((a, b) => {
// //         const pa = getStatus(a.order) === statusPin ? 0 : 1;
// //         const pb = getStatus(b.order) === statusPin ? 0 : 1;
// //         if (pa !== pb) return pa - pb;
// //         return cmpDate(a, b);
// //       });
// //     } else {
// //       arr.sort(cmpDate);
// //     }

// //     return arr;
// //   }, [filtered, sortDir, statusPin, statusOnly]);

// //   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
// //   const pageClamped = Math.min(page, totalPages);
// //   const start = (pageClamped - 1) * pageSize;
// //   const end = start + pageSize;
// //   const paged = sorted.slice(start, end);

// //   const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

// //   // ===== STATUS =====
// //   const beginEditStatus = (order, e) => {
// //     e?.stopPropagation?.();
// //     setEditingStatusId(order.id);
// //     setStatusDraft(getStatus(order));
// //   };

// //   const cancelEditStatus = () => {
// //     setEditingStatusId(null);
// //     setStatusDraft("");
// //   };

// //   const saveStatusToDb = async (orderId, nextStatusRaw) => {
// //     const nextStatus =
// //       String(nextStatusRaw || "").trim() || "Очікує підтвердження";

// //     const row = orders.find((r) => r.order.id === orderId);
// //     const currentOrder = row?.order || {};
// //     const currentTtn = getTtn(currentOrder);

// //     if (
// //       TTN_REQUIRED_STATUSES.has(nextStatus) &&
// //       !String(currentTtn || "").trim()
// //     ) {
// //       alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
// //       return;
// //     }

// //     const canceled = nextStatus === "Скасовано";
// //     const nowISO = new Date().toISOString();

// //     await updateDoc(doc(db, "orders", orderId), {
// //       status: nextStatus,
// //       canceled,
// //       updatedAt: serverTimestamp(),
// //       updatedAtISO: nowISO,
// //       statusFlow: { current: nextStatus, updatedAtISO: nowISO },
// //     });

// //     setOrders((arr) =>
// //       arr.map((r) =>
// //         r.order.id === orderId
// //           ? {
// //               ...r,
// //               order: {
// //                 ...r.order,
// //                 status: nextStatus,
// //                 canceled,
// //                 updatedAtISO: nowISO,
// //                 statusFlow: {
// //                   ...(r.order?.statusFlow || {}),
// //                   current: nextStatus,
// //                   updatedAtISO: nowISO,
// //                 },
// //               },
// //             }
// //           : r,
// //       ),
// //     );
// //   };

// //   const saveStatus = async (orderId) => {
// //     await saveStatusToDb(orderId, statusDraft);
// //     cancelEditStatus();
// //   };

// //   const onStatusKey = (e, orderId) => {
// //     if (e.key === "Enter") saveStatus(orderId);
// //     if (e.key === "Escape") cancelEditStatus();
// //   };

// //   // ===== TTN =====
// //   const beginEditTTN = (order) => {
// //     setEditingTtnId(order.id);
// //     setTtnDraft(String(getTtn(order) || ""));
// //   };

// //   const cancelEditTTN = () => {
// //     setEditingTtnId(null);
// //     setTtnDraft("");
// //   };

// //   const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
// //     const normalized = String(ttnValue || "")
// //       .replace(/\D/g, "")
// //       .trim();
// //     if (!/^\d{8,14}$/.test(normalized)) {
// //       alert("Введіть коректний номер ТТН (8–14 цифр).");
// //       return;
// //     }

// //     const row = orders.find((r) => r.order.id === orderId);
// //     const currentOrder = row?.order || {};
// //     const currentStatus = getStatus(currentOrder);
// //     const nextStatus = options.setStatusAfterSave
// //       ? "ТТН НП внесено"
// //       : currentStatus;

// //     const nowISO = new Date().toISOString();

// //     await updateDoc(doc(db, "orders", orderId), {
// //       ttn: normalized,
// //       status: nextStatus,
// //       updatedAt: serverTimestamp(),
// //       updatedAtISO: nowISO,
// //       delivery: { ...(currentOrder?.delivery || {}), ttn: normalized },
// //       logistics: {
// //         ...(currentOrder?.logistics || {}),
// //         provider: "Нова пошта",
// //         providerLabel: "Нова пошта",
// //         ttn: normalized,
// //         updatedAtISO: nowISO,
// //       },
// //     });

// //     setOrders((arr) =>
// //       arr.map((r) => {
// //         if (r.order.id !== orderId) return r;
// //         return {
// //           ...r,
// //           order: {
// //             ...r.order,
// //             ttn: normalized,
// //             status: nextStatus,
// //             updatedAtISO: nowISO,
// //             delivery: { ...(r.order?.delivery || {}), ttn: normalized },
// //             logistics: {
// //               ...(r.order?.logistics || {}),
// //               provider: "Нова пошта",
// //               providerLabel: "Нова пошта",
// //               ttn: normalized,
// //               updatedAtISO: nowISO,
// //             },
// //           },
// //         };
// //       }),
// //     );
// //   };

// //   const saveTTN = async (orderId) => {
// //     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
// //     cancelEditTTN();
// //   };

// //   const saveTTNAndSetStatus = async (orderId) => {
// //     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
// //     cancelEditTTN();
// //   };

// //   const onTtnKey = (e, orderId) => {
// //     if (e.key === "Enter") saveTTN(orderId);
// //     if (e.key === "Escape") cancelEditTTN();
// //   };
// //   // ===== ITEMS EDIT LOGIC =====
// //   const beginEditItems = (rowOrOrder) => {
// //     const order = rowOrOrder?.order ? rowOrOrder.order : rowOrOrder;

// //     const ch = parseChoice(order?.choice);

// //     const normalized = (Array.isArray(ch) ? ch : []).map((it, idx) => {
// //       const quantity = Math.max(1, Number(it?.quantity ?? it?.qty ?? 1) || 1);
// //       const realUnitPrice = getItemFinalUnitPrice(it);

// //       const rawBasePrice = Number(it?.basePrice);
// //       const rawPrice = Number(it?.price);

// //       const basePrice =
// //         Number.isFinite(rawBasePrice) && rawBasePrice > 0
// //           ? rawBasePrice
// //           : Number.isFinite(rawPrice) && rawPrice > realUnitPrice
// //             ? rawPrice
// //             : realUnitPrice;

// //       const rawLineTotal = Number(it?.lineTotal);
// //       const lineTotal =
// //         Number.isFinite(rawLineTotal) && rawLineTotal > 0
// //           ? rawLineTotal
// //           : Number((realUnitPrice * quantity).toFixed(2));

// //       return {
// //         ...it,
// //         __key: `${it.uid || it.id || it.productId || "x"}-${idx}`,
// //         isNew: false,
// //         quantity,

// //         // важливо для бекенду при повторному збереженні
// //         price: realUnitPrice,
// //         finalPrice: realUnitPrice,
// //         unitPrice: realUnitPrice,
// //         purchasedUnitPrice:
// //           Number(it?.purchasedUnitPrice) > 0
// //             ? Number(it.purchasedUnitPrice)
// //             : realUnitPrice,

// //         basePrice,
// //         lineTotal,
// //       };
// //     });

// //     setEditingItemsId(order.id);
// //     setExpanded((s) => ({ ...s, [order.id]: true }));
// //     setItemsDraft(normalized);
// //     setNewPid("");
// //     setNewQty(1);
// //   };

// //   const cancelEditItems = () => {
// //     setEditingItemsId(null);
// //     setItemsDraft([]);
// //     setNewPid("");
// //     setNewQty(1);
// //     setSavingItems(false);
// //   };

// //   const setItemQty = (__key, qty) => {
// //     const q = Math.max(1, Number(qty) || 1);
// //     setItemsDraft((arr) =>
// //       arr.map((it) => (it.__key === __key ? { ...it, quantity: q } : it)),
// //     );
// //   };

// //   const removeDraftItem = (__key) => {
// //     setItemsDraft((arr) => arr.filter((it) => it.__key !== __key));
// //   };

// //   // опціонально: якщо додаєш той самий productId — просто збільшуємо кількість
// //   const addDraftItem = (product, qty = 1) => {
// //     const pid = String(product?.id || "").trim();
// //     if (!pid) return;

// //     const q = Math.max(1, Number(qty) || 1);

// //     const title = product?.bookName || product?.name || `ID: ${pid}`;

// //     setItemsDraft((arr) => {
// //       const existsIdx = arr.findIndex(
// //         (x) => String(x.productId || x.id || x.uid || "").trim() === pid,
// //       );

// //       // якщо вже є в чернетці — додаємо кількість
// //       if (existsIdx !== -1) {
// //         return arr.map((x, i) =>
// //           i === existsIdx ? { ...x, quantity: (x.quantity || 1) + q } : x,
// //         );
// //       }

// //       // новий рядок — isNew:true (бекенд перерахує ціну)
// //       return [
// //         ...arr,
// //         {
// //           __key: `new-${Date.now()}-${Math.random()}`,
// //           productId: pid,
// //           id: pid,
// //           uid: pid,
// //           quantity: q,
// //           isNew: true,

// //           name: title,
// //           bookName: title,

// //           // можна додати прев’ю, щоб було красиво
// //           imageList: Array.isArray(product?.imageList) ? product.imageList : [],
// //           images: Array.isArray(product?.images) ? product.images : [],
// //           textAutor: product?.textAutor || "",
// //           seria: product?.seria || product?.series || "",
// //         },
// //       ];
// //     });
// //   };

// //   const saveItems = async (orderId, paymentMethodRaw) => {
// //     if (savingItems) return null;
// //     setSavingItems(true);

// //     try {
// //       const backend = "https://chas-maistriv.com.ua/api";

// //       const payload = {
// //         orderId,
// //         items: itemsDraft.map(({ __key, ...it }) => ({
// //           ...it,
// //           // гарантуємо, що quantity число
// //           quantity: Math.max(1, Number(it.quantity || 1) || 1),
// //         })),
// //       };

// //       const resp = await fetch(`${backend}/admin/order/update-items`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify(payload),
// //       });

// //       const json = await resp.json();
// //       if (!resp.ok) throw new Error(json?.error || "Save failed");

// //       // КЛЮЧ: перечитуємо order з Firestore (щоб побачити правильні ціни/лінки)
// //       await reloadOneOrder(orderId);

// //       cancelEditItems();
// //       return json;
// //     } finally {
// //       setSavingItems(false);
// //     }
// //   };
// //   return {
// //     orders,
// //     paged,
// //     expanded,
// //     toggleExpand,

// //     // filters
// //     sortDir,
// //     setSortDir,
// //     statusPin,
// //     setStatusPin,
// //     statusOnly,
// //     setStatusOnly,
// //     dateFrom,
// //     setDateFrom,
// //     dateTo,
// //     setDateTo,

// //     // paging
// //     pageSize,
// //     setPageSize,
// //     totalPages,
// //     pageClamped,
// //     goto,

// //     // status
// //     editingStatusId,
// //     statusDraft,
// //     setStatusDraft,
// //     beginEditStatus,
// //     saveStatus,
// //     cancelEditStatus,
// //     onStatusKey,

// //     // ttn
// //     editingTtnId,
// //     ttnDraft,
// //     setTtnDraft,
// //     beginEditTTN,
// //     saveTTN,
// //     saveTTNAndSetStatus,
// //     cancelEditTTN,
// //     onTtnKey,
// //     // items edit
// //     editingItemsId,
// //     itemsDraft,
// //     newPid,
// //     setNewPid,
// //     newQty,
// //     setNewQty,
// //     savingItems,
// //     beginEditItems,
// //     cancelEditItems,
// //     setItemQty,
// //     removeDraftItem,
// //     addDraftItem,
// //     saveItems,
// //     STATUS_OPTIONS,
// //   };
// // }
// import { useEffect, useMemo, useRef, useState } from "react";
// import {
//   collection,
//   getDocs,
//   getDoc,
//   doc,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../../firebase";

// import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
// import {
//   parseChoice,
//   getStatus,
//   getTtn,
//   ts,
//   dayStart,
//   dayEnd,
//   getItemFinalUnitPrice,
// } from "./orderUtils";

// export function useOrdersManager(initialPageSize = 10, initialPage = 1) {
//   const normalizedInitialPage = Math.max(1, Number(initialPage) || 1);

//   const [orders, setOrders] = useState([]); // [{ order, choice }]
//   const [expanded, setExpanded] = useState({});

//   // status edit
//   const [editingStatusId, setEditingStatusId] = useState(null);
//   const [statusDraft, setStatusDraft] = useState("");

//   // ttn edit
//   const [editingTtnId, setEditingTtnId] = useState(null);
//   const [ttnDraft, setTtnDraft] = useState("");

//   // items edit
//   const [editingItemsId, setEditingItemsId] = useState(null);
//   const [itemsDraft, setItemsDraft] = useState([]);
//   const [newPid, setNewPid] = useState("");
//   const [newQty, setNewQty] = useState(1);
//   const [savingItems, setSavingItems] = useState(false);

//   // filters / sort
//   const [sortDir, setSortDir] = useState("desc");
//   const [statusPin, setStatusPin] = useState("Усі");
//   const [statusOnly, setStatusOnly] = useState(false);
//   const [dateFrom, setDateFrom] = useState("");
//   const [dateTo, setDateTo] = useState("");

//   // paging
//   // const [page, setPage] = useState(normalizedInitialPage);
//   // const [pageSize, setPageSize] = useState(initialPageSize);
//   // const [isLoaded, setIsLoaded] = useState(false);
//   const page = normalizedInitialPage;
//   const [pageSize, setPageSize] = useState(initialPageSize);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const buildRow = (docSnapOrId, dataMaybe) => {
//     // варіант 1: коли передаємо snap (getDoc / getDocs item)
//     if (docSnapOrId?.exists && docSnapOrId.exists()) {
//       const raw = { id: docSnapOrId.id, ...docSnapOrId.data() };
//       return { order: raw, choice: parseChoice(raw?.choice) };
//     }

//     // варіант 2: коли передаємо id + data
//     const id = String(docSnapOrId || "");
//     const raw = { id, ...(dataMaybe || {}) };
//     return { order: raw, choice: parseChoice(raw?.choice) };
//   };

//   const loadOrders = async () => {
//     const snap = await getDocs(collection(db, "orders"));
//     const rows = [];

//     snap.forEach((d) => {
//       rows.push(buildRow(d));
//     });

//     return rows;
//   };

//   const reloadOneOrder = async (orderId) => {
//     const ref = doc(db, "orders", String(orderId));
//     const snap = await getDoc(ref);

//     if (!snap.exists()) return;

//     const updatedRow = buildRow(snap);

//     setOrders((arr) =>
//       arr.map((r) => (r.order.id === String(orderId) ? updatedRow : r)),
//     );
//   };

//   useEffect(() => {
//     let alive = true;

//     (async () => {
//       try {
//         setIsLoaded(false);

//         const rows = await loadOrders();
//         if (!alive) return;

//         setOrders(rows);
//         setIsLoaded(true);
//       } catch (e) {
//         console.error("OrderList load error:", e);
//         if (!alive) return;

//         setOrders([]);
//         setIsLoaded(true);
//       }
//     })();

//     return () => {
//       alive = false;
//     };
//   }, []);

//   // Синхронізація сторінки з URL (/adm/order/:page)

//   // Коли змінюються фільтри / pageSize / кількість замовлень — скидаємо на 1 сторінку.
//   // ВАЖЛИВО: пропускаємо перший рендер, інакше initialPage з URL одразу затреться на 1.

//   const toggleExpand = (id) => {
//     setExpanded((s) => ({ ...s, [id]: !s[id] }));
//   };

//   const filtered = useMemo(() => {
//     let arr = [...orders];

//     if (statusOnly && statusPin !== "Усі") {
//       arr = arr.filter(({ order }) => getStatus(order) === statusPin);
//     }

//     if (dateFrom || dateTo) {
//       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
//       const toMs = dateTo ? dayEnd(dateTo) : Infinity;

//       arr = arr.filter(({ order }) => {
//         const t = ts(order);
//         return t >= fromMs && t <= toMs;
//       });
//     }

//     return arr;
//   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

//   const sorted = useMemo(() => {
//     const arr = [...filtered];

//     const cmpDate = (a, b) => {
//       const A = ts(a.order);
//       const B = ts(b.order);
//       return sortDir === "asc" ? A - B : B - A;
//     };

//     if (statusPin !== "Усі" && !statusOnly) {
//       arr.sort((a, b) => {
//         const pa = getStatus(a.order) === statusPin ? 0 : 1;
//         const pb = getStatus(b.order) === statusPin ? 0 : 1;

//         if (pa !== pb) return pa - pb;

//         return cmpDate(a, b);
//       });
//     } else {
//       arr.sort(cmpDate);
//     }

//     return arr;
//   }, [filtered, sortDir, statusPin, statusOnly]);

//   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
//   const pageClamped = Math.min(page, totalPages);
//   const start = (pageClamped - 1) * pageSize;
//   const end = start + pageSize;
//   const paged = sorted.slice(start, end);

//   const goto = (p) => Math.min(Math.max(1, Number(p) || 1), totalPages);

//   // ===== STATUS =====
//   const beginEditStatus = (order, e) => {
//     e?.stopPropagation?.();
//     setEditingStatusId(order.id);
//     setStatusDraft(getStatus(order));
//   };

//   const cancelEditStatus = () => {
//     setEditingStatusId(null);
//     setStatusDraft("");
//   };

//   const saveStatusToDb = async (orderId, nextStatusRaw) => {
//     const nextStatus =
//       String(nextStatusRaw || "").trim() || "Очікує підтвердження";

//     const row = orders.find((r) => r.order.id === orderId);
//     const currentOrder = row?.order || {};
//     const currentTtn = getTtn(currentOrder);

//     if (
//       TTN_REQUIRED_STATUSES.has(nextStatus) &&
//       !String(currentTtn || "").trim()
//     ) {
//       alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
//       return;
//     }

//     const canceled = nextStatus === "Скасовано";
//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       status: nextStatus,
//       canceled,
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,
//       statusFlow: {
//         current: nextStatus,
//         updatedAtISO: nowISO,
//       },
//     });

//     setOrders((arr) =>
//       arr.map((r) =>
//         r.order.id === orderId
//           ? {
//               ...r,
//               order: {
//                 ...r.order,
//                 status: nextStatus,
//                 canceled,
//                 updatedAtISO: nowISO,
//                 statusFlow: {
//                   ...(r.order?.statusFlow || {}),
//                   current: nextStatus,
//                   updatedAtISO: nowISO,
//                 },
//               },
//             }
//           : r,
//       ),
//     );
//   };

//   const saveStatus = async (orderId) => {
//     await saveStatusToDb(orderId, statusDraft);
//     cancelEditStatus();
//   };

//   const onStatusKey = (e, orderId) => {
//     if (e.key === "Enter") saveStatus(orderId);
//     if (e.key === "Escape") cancelEditStatus();
//   };

//   // ===== TTN =====
//   const beginEditTTN = (order) => {
//     setEditingTtnId(order.id);
//     setTtnDraft(String(getTtn(order) || ""));
//   };

//   const cancelEditTTN = () => {
//     setEditingTtnId(null);
//     setTtnDraft("");
//   };

//   const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
//     const normalized = String(ttnValue || "")
//       .replace(/\D/g, "")
//       .trim();

//     if (!/^\d{8,14}$/.test(normalized)) {
//       alert("Введіть коректний номер ТТН (8–14 цифр).");
//       return;
//     }

//     const row = orders.find((r) => r.order.id === orderId);
//     const currentOrder = row?.order || {};
//     const currentStatus = getStatus(currentOrder);
//     const nextStatus = options.setStatusAfterSave
//       ? "ТТН НП внесено"
//       : currentStatus;

//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       ttn: normalized,
//       status: nextStatus,
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,
//       delivery: {
//         ...(currentOrder?.delivery || {}),
//         ttn: normalized,
//       },
//       logistics: {
//         ...(currentOrder?.logistics || {}),
//         provider: "Нова пошта",
//         providerLabel: "Нова пошта",
//         ttn: normalized,
//         updatedAtISO: nowISO,
//       },
//     });

//     setOrders((arr) =>
//       arr.map((r) => {
//         if (r.order.id !== orderId) return r;

//         return {
//           ...r,
//           order: {
//             ...r.order,
//             ttn: normalized,
//             status: nextStatus,
//             updatedAtISO: nowISO,
//             delivery: {
//               ...(r.order?.delivery || {}),
//               ttn: normalized,
//             },
//             logistics: {
//               ...(r.order?.logistics || {}),
//               provider: "Нова пошта",
//               providerLabel: "Нова пошта",
//               ttn: normalized,
//               updatedAtISO: nowISO,
//             },
//           },
//         };
//       }),
//     );
//   };

//   const saveTTN = async (orderId) => {
//     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
//     cancelEditTTN();
//   };

//   const saveTTNAndSetStatus = async (orderId) => {
//     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
//     cancelEditTTN();
//   };

//   const onTtnKey = (e, orderId) => {
//     if (e.key === "Enter") saveTTN(orderId);
//     if (e.key === "Escape") cancelEditTTN();
//   };

//   // ===== ITEMS EDIT =====
//   const beginEditItems = (rowOrOrder) => {
//     const order = rowOrOrder?.order ? rowOrOrder.order : rowOrOrder;
//     const ch = parseChoice(order?.choice);

//     const normalized = (Array.isArray(ch) ? ch : []).map((it, idx) => {
//       const quantity = Math.max(1, Number(it?.quantity ?? it?.qty ?? 1) || 1);
//       const realUnitPrice = getItemFinalUnitPrice(it);

//       const rawBasePrice = Number(it?.basePrice);
//       const rawPrice = Number(it?.price);

//       const basePrice =
//         Number.isFinite(rawBasePrice) && rawBasePrice > 0
//           ? rawBasePrice
//           : Number.isFinite(rawPrice) && rawPrice > realUnitPrice
//             ? rawPrice
//             : realUnitPrice;

//       const rawLineTotal = Number(it?.lineTotal);
//       const lineTotal =
//         Number.isFinite(rawLineTotal) && rawLineTotal > 0
//           ? rawLineTotal
//           : Number((realUnitPrice * quantity).toFixed(2));

//       return {
//         ...it,
//         __key: `${it.uid || it.id || it.productId || "x"}-${idx}`,
//         isNew: false,
//         quantity,

//         // важливо для бекенду при повторному збереженні
//         price: realUnitPrice,
//         finalPrice: realUnitPrice,
//         unitPrice: realUnitPrice,
//         purchasedUnitPrice:
//           Number(it?.purchasedUnitPrice) > 0
//             ? Number(it.purchasedUnitPrice)
//             : realUnitPrice,

//         basePrice,
//         lineTotal,
//       };
//     });

//     setEditingItemsId(order.id);
//     setExpanded((s) => ({ ...s, [order.id]: true }));
//     setItemsDraft(normalized);
//     setNewPid("");
//     setNewQty(1);
//   };

//   const cancelEditItems = () => {
//     setEditingItemsId(null);
//     setItemsDraft([]);
//     setNewPid("");
//     setNewQty(1);
//     setSavingItems(false);
//   };

//   const setItemQty = (__key, qty) => {
//     const q = Math.max(1, Number(qty) || 1);

//     setItemsDraft((arr) =>
//       arr.map((it) => (it.__key === __key ? { ...it, quantity: q } : it)),
//     );
//   };

//   const removeDraftItem = (__key) => {
//     setItemsDraft((arr) => arr.filter((it) => it.__key !== __key));
//   };

//   const addDraftItem = (product, qty = 1) => {
//     const pid = String(product?.id || "").trim();
//     if (!pid) return;

//     const q = Math.max(1, Number(qty) || 1);
//     const title = product?.bookName || product?.name || `ID: ${pid}`;

//     setItemsDraft((arr) => {
//       const existsIdx = arr.findIndex(
//         (x) => String(x.productId || x.id || x.uid || "").trim() === pid,
//       );

//       if (existsIdx !== -1) {
//         return arr.map((x, i) =>
//           i === existsIdx ? { ...x, quantity: (x.quantity || 1) + q } : x,
//         );
//       }

//       return [
//         ...arr,
//         {
//           __key: `new-${Date.now()}-${Math.random()}`,
//           productId: pid,
//           id: pid,
//           uid: pid,
//           quantity: q,
//           isNew: true,

//           name: title,
//           bookName: title,

//           imageList: Array.isArray(product?.imageList) ? product.imageList : [],
//           images: Array.isArray(product?.images) ? product.images : [],
//           textAutor: product?.textAutor || "",
//           seria: product?.seria || product?.series || "",
//         },
//       ];
//     });
//   };

//   const saveItems = async (orderId) => {
//     if (savingItems) return null;
//     setSavingItems(true);

//     try {
//       const backend = "https://chas-maistriv.com.ua/api";

//       const payload = {
//         orderId,
//         items: itemsDraft.map(({ __key, ...it }) => ({
//           ...it,
//           quantity: Math.max(1, Number(it.quantity || 1) || 1),
//         })),
//       };

//       const resp = await fetch(`${backend}/admin/order/update-items`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const json = await resp.json();

//       if (!resp.ok) {
//         throw new Error(json?.error || "Save failed");
//       }

//       await reloadOneOrder(orderId);

//       cancelEditItems();
//       return json;
//     } finally {
//       setSavingItems(false);
//     }
//   };

//   return {
//     orders,
//     paged,
//     expanded,
//     toggleExpand,

//     // filters
//     sortDir,
//     setSortDir,
//     statusPin,
//     setStatusPin,
//     statusOnly,
//     setStatusOnly,
//     dateFrom,
//     setDateFrom,
//     dateTo,
//     setDateTo,

//     // paging
//     page,
//     pageSize,
//     setPageSize,
//     totalPages,
//     pageClamped,
//     goto,

//     // status
//     editingStatusId,
//     statusDraft,
//     setStatusDraft,
//     beginEditStatus,
//     saveStatus,
//     cancelEditStatus,
//     onStatusKey,

//     // ttn
//     editingTtnId,
//     ttnDraft,
//     setTtnDraft,
//     beginEditTTN,
//     saveTTN,
//     saveTTNAndSetStatus,
//     cancelEditTTN,
//     onTtnKey,
//     isLoaded,
//     // items edit
//     editingItemsId,
//     itemsDraft,
//     newPid,
//     setNewPid,
//     newQty,
//     setNewQty,
//     savingItems,
//     beginEditItems,
//     cancelEditItems,
//     setItemQty,
//     removeDraftItem,
//     addDraftItem,
//     saveItems,

//     STATUS_OPTIONS,
//   };
// }
import { useEffect, useMemo, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../../firebase";

import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
import {
  parseChoice,
  getStatus,
  getTtn,
  ts,
  dayStart,
  dayEnd,
  getItemFinalUnitPrice,
  getUserCategory,
} from "./orderUtils";

const ROLES = {
  CLUB: 'Член "Клубу Майстрів"',
  LIBRARIAN: "Бібліотекар",
  BUSINESS: "Бізнес-партнер",
  MASTER: "Майстер",
};

const ROLE_OPTIONS = [
  ROLES.BUSINESS,
  ROLES.LIBRARIAN,
  ROLES.MASTER,
  ROLES.CLUB,
];

function normalizeRole(value) {
  const v = String(value || "")
    .trim()
    .toLowerCase();

  if (!v) return "";

  if (
    v === "business" ||
    v === "бізнес" ||
    v === "бізнес-партнер" ||
    v === "бизнес" ||
    v === "бизнес-партнер"
  ) {
    return ROLES.BUSINESS;
  }

  if (v === "librarian" || v === "бібліотекар" || v === "библиотекарь") {
    return ROLES.LIBRARIAN;
  }

  if (v === "master" || v === "майстер" || v === "мастер") {
    return ROLES.MASTER;
  }

  if (
    v === "club" ||
    v === "club_member" ||
    v === "club member" ||
    v === "член клубу майстрів" ||
    v === 'член "клубу майстрів"'
  ) {
    return ROLES.CLUB;
  }

  return String(value || "").trim();
}

function getRoleRank(order) {
  const role = normalizeRole(getUserCategory(order));

  switch (role) {
    case ROLES.BUSINESS:
      return 0;
    case ROLES.LIBRARIAN:
      return 1;
    case ROLES.MASTER:
      return 2;
    case ROLES.CLUB:
      return 3;
    default:
      return 999;
  }
}

export function useOrdersManager(initialPageSize = 10, initialPage = 1) {
  const normalizedInitialPage = Math.max(1, Number(initialPage) || 1);

  const [orders, setOrders] = useState([]); // [{ order, choice }]
  const [expanded, setExpanded] = useState({});

  // status edit
  const [editingStatusId, setEditingStatusId] = useState(null);
  const [statusDraft, setStatusDraft] = useState("");

  // ttn edit
  const [editingTtnId, setEditingTtnId] = useState(null);
  const [ttnDraft, setTtnDraft] = useState("");

  // items edit
  const [editingItemsId, setEditingItemsId] = useState(null);
  const [itemsDraft, setItemsDraft] = useState([]);
  const [newPid, setNewPid] = useState("");
  const [newQty, setNewQty] = useState(1);
  const [savingItems, setSavingItems] = useState(false);

  // filters / sort
  const [sortDir, setSortDir] = useState("desc");
  const [statusPin, setStatusPin] = useState("Усі");
  const [statusOnly, setStatusOnly] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("Усі");
  const [categorySort, setCategorySort] = useState(false);

  // paging
  const page = normalizedInitialPage;
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [isLoaded, setIsLoaded] = useState(false);

  const buildRow = (docSnapOrId, dataMaybe) => {
    if (docSnapOrId?.exists && docSnapOrId.exists()) {
      const raw = { id: docSnapOrId.id, ...docSnapOrId.data() };
      return { order: raw, choice: parseChoice(raw?.choice) };
    }

    const id = String(docSnapOrId || "");
    const raw = { id, ...(dataMaybe || {}) };
    return { order: raw, choice: parseChoice(raw?.choice) };
  };

  const loadOrders = async () => {
    const snap = await getDocs(collection(db, "orders"));
    const rows = [];

    snap.forEach((d) => {
      rows.push(buildRow(d));
    });

    return rows;
  };

  const reloadOneOrder = async (orderId) => {
    const ref = doc(db, "orders", String(orderId));
    const snap = await getDoc(ref);

    if (!snap.exists()) return;

    const updatedRow = buildRow(snap);

    setOrders((arr) =>
      arr.map((r) => (r.order.id === String(orderId) ? updatedRow : r)),
    );
  };

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        setIsLoaded(false);

        const rows = await loadOrders();
        if (!alive) return;

        setOrders(rows);
        setIsLoaded(true);
      } catch (e) {
        console.error("OrderList load error:", e);
        if (!alive) return;

        setOrders([]);
        setIsLoaded(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  const toggleExpand = (id) => {
    setExpanded((s) => ({ ...s, [id]: !s[id] }));
  };

  const filtered = useMemo(() => {
    let arr = [...orders];

    if (statusOnly && statusPin !== "Усі") {
      arr = arr.filter(({ order }) => getStatus(order) === statusPin);
    }

    if (dateFrom || dateTo) {
      const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
      const toMs = dateTo ? dayEnd(dateTo) : Infinity;

      arr = arr.filter(({ order }) => {
        const t = ts(order);
        return t >= fromMs && t <= toMs;
      });
    }

    if (categoryFilter !== "Усі") {
      arr = arr.filter(({ order }) => {
        const role = normalizeRole(getUserCategory(order));
        return role === categoryFilter;
      });
    }

    return arr;
  }, [orders, statusOnly, statusPin, dateFrom, dateTo, categoryFilter]);

  const sorted = useMemo(() => {
    const arr = [...filtered];

    const cmpDate = (a, b) => {
      const A = ts(a.order);
      const B = ts(b.order);
      return sortDir === "asc" ? A - B : B - A;
    };

    const cmpRoleThenDate = (a, b) => {
      if (categorySort) {
        const roleDiff = getRoleRank(a.order) - getRoleRank(b.order);
        if (roleDiff !== 0) return roleDiff;
      }

      return cmpDate(a, b);
    };

    if (statusPin !== "Усі" && !statusOnly) {
      arr.sort((a, b) => {
        const pa = getStatus(a.order) === statusPin ? 0 : 1;
        const pb = getStatus(b.order) === statusPin ? 0 : 1;

        if (pa !== pb) return pa - pb;

        return cmpRoleThenDate(a, b);
      });
    } else {
      arr.sort(cmpRoleThenDate);
    }

    return arr;
  }, [filtered, sortDir, statusPin, statusOnly, categorySort]);

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const pageClamped = Math.min(page, totalPages);
  const start = (pageClamped - 1) * pageSize;
  const end = start + pageSize;
  const paged = sorted.slice(start, end);

  const goto = (p) => Math.min(Math.max(1, Number(p) || 1), totalPages);

  // ===== STATUS =====
  const beginEditStatus = (order, e) => {
    e?.stopPropagation?.();
    setEditingStatusId(order.id);
    setStatusDraft(getStatus(order));
  };

  const cancelEditStatus = () => {
    setEditingStatusId(null);
    setStatusDraft("");
  };

  const saveStatusToDb = async (orderId, nextStatusRaw) => {
    const nextStatus =
      String(nextStatusRaw || "").trim() || "Очікує підтвердження";

    const row = orders.find((r) => r.order.id === orderId);
    const currentOrder = row?.order || {};
    const currentTtn = getTtn(currentOrder);

    if (
      TTN_REQUIRED_STATUSES.has(nextStatus) &&
      !String(currentTtn || "").trim()
    ) {
      alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
      return;
    }

    const canceled = nextStatus === "Скасовано";
    const nowISO = new Date().toISOString();

    await updateDoc(doc(db, "orders", orderId), {
      status: nextStatus,
      canceled,
      updatedAt: serverTimestamp(),
      updatedAtISO: nowISO,
      statusFlow: {
        current: nextStatus,
        updatedAtISO: nowISO,
      },
    });

    setOrders((arr) =>
      arr.map((r) =>
        r.order.id === orderId
          ? {
              ...r,
              order: {
                ...r.order,
                status: nextStatus,
                canceled,
                updatedAtISO: nowISO,
                statusFlow: {
                  ...(r.order?.statusFlow || {}),
                  current: nextStatus,
                  updatedAtISO: nowISO,
                },
              },
            }
          : r,
      ),
    );
  };

  const saveStatus = async (orderId) => {
    await saveStatusToDb(orderId, statusDraft);
    cancelEditStatus();
  };

  const onStatusKey = (e, orderId) => {
    if (e.key === "Enter") saveStatus(orderId);
    if (e.key === "Escape") cancelEditStatus();
  };

  // ===== TTN =====
  const beginEditTTN = (order) => {
    setEditingTtnId(order.id);
    setTtnDraft(String(getTtn(order) || ""));
  };

  const cancelEditTTN = () => {
    setEditingTtnId(null);
    setTtnDraft("");
  };

  const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
    const normalized = String(ttnValue || "")
      .replace(/\D/g, "")
      .trim();

    if (!/^\d{8,14}$/.test(normalized)) {
      alert("Введіть коректний номер ТТН (8–14 цифр).");
      return;
    }

    const row = orders.find((r) => r.order.id === orderId);
    const currentOrder = row?.order || {};
    const currentStatus = getStatus(currentOrder);
    const nextStatus = options.setStatusAfterSave
      ? "ТТН НП внесено"
      : currentStatus;

    const nowISO = new Date().toISOString();

    await updateDoc(doc(db, "orders", orderId), {
      ttn: normalized,
      status: nextStatus,
      updatedAt: serverTimestamp(),
      updatedAtISO: nowISO,
      delivery: {
        ...(currentOrder?.delivery || {}),
        ttn: normalized,
      },
      logistics: {
        ...(currentOrder?.logistics || {}),
        provider: "Нова пошта",
        providerLabel: "Нова пошта",
        ttn: normalized,
        updatedAtISO: nowISO,
      },
    });

    setOrders((arr) =>
      arr.map((r) => {
        if (r.order.id !== orderId) return r;

        return {
          ...r,
          order: {
            ...r.order,
            ttn: normalized,
            status: nextStatus,
            updatedAtISO: nowISO,
            delivery: {
              ...(r.order?.delivery || {}),
              ttn: normalized,
            },
            logistics: {
              ...(r.order?.logistics || {}),
              provider: "Нова пошта",
              providerLabel: "Нова пошта",
              ttn: normalized,
              updatedAtISO: nowISO,
            },
          },
        };
      }),
    );
  };

  const saveTTN = async (orderId) => {
    await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
    cancelEditTTN();
  };

  const saveTTNAndSetStatus = async (orderId) => {
    await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
    cancelEditTTN();
  };

  const onTtnKey = (e, orderId) => {
    if (e.key === "Enter") saveTTN(orderId);
    if (e.key === "Escape") cancelEditTTN();
  };

  // ===== ITEMS EDIT =====
  const beginEditItems = (rowOrOrder) => {
    const order = rowOrOrder?.order ? rowOrOrder.order : rowOrOrder;
    const ch = parseChoice(order?.choice);

    const normalized = (Array.isArray(ch) ? ch : []).map((it, idx) => {
      const quantity = Math.max(1, Number(it?.quantity ?? it?.qty ?? 1) || 1);
      const realUnitPrice = getItemFinalUnitPrice(it);

      const rawBasePrice = Number(it?.basePrice);
      const rawPrice = Number(it?.price);

      const basePrice =
        Number.isFinite(rawBasePrice) && rawBasePrice > 0
          ? rawBasePrice
          : Number.isFinite(rawPrice) && rawPrice > realUnitPrice
            ? rawPrice
            : realUnitPrice;

      const rawLineTotal = Number(it?.lineTotal);
      const lineTotal =
        Number.isFinite(rawLineTotal) && rawLineTotal > 0
          ? rawLineTotal
          : Number((realUnitPrice * quantity).toFixed(2));

      return {
        ...it,
        __key: `${it.uid || it.id || it.productId || "x"}-${idx}`,
        isNew: false,
        quantity,

        price: realUnitPrice,
        finalPrice: realUnitPrice,
        unitPrice: realUnitPrice,
        purchasedUnitPrice:
          Number(it?.purchasedUnitPrice) > 0
            ? Number(it.purchasedUnitPrice)
            : realUnitPrice,

        basePrice,
        lineTotal,
      };
    });

    setEditingItemsId(order.id);
    setExpanded((s) => ({ ...s, [order.id]: true }));
    setItemsDraft(normalized);
    setNewPid("");
    setNewQty(1);
  };

  const cancelEditItems = () => {
    setEditingItemsId(null);
    setItemsDraft([]);
    setNewPid("");
    setNewQty(1);
    setSavingItems(false);
  };

  const setItemQty = (__key, qty) => {
    const q = Math.max(1, Number(qty) || 1);

    setItemsDraft((arr) =>
      arr.map((it) => (it.__key === __key ? { ...it, quantity: q } : it)),
    );
  };

  const removeDraftItem = (__key) => {
    setItemsDraft((arr) => arr.filter((it) => it.__key !== __key));
  };

  const addDraftItem = (product, qty = 1) => {
    const pid = String(product?.id || "").trim();
    if (!pid) return;

    const q = Math.max(1, Number(qty) || 1);
    const title = product?.bookName || product?.name || `ID: ${pid}`;

    setItemsDraft((arr) => {
      const existsIdx = arr.findIndex(
        (x) => String(x.productId || x.id || x.uid || "").trim() === pid,
      );

      if (existsIdx !== -1) {
        return arr.map((x, i) =>
          i === existsIdx ? { ...x, quantity: (x.quantity || 1) + q } : x,
        );
      }

      return [
        ...arr,
        {
          __key: `new-${Date.now()}-${Math.random()}`,
          productId: pid,
          id: pid,
          uid: pid,
          quantity: q,
          isNew: true,

          name: title,
          bookName: title,

          imageList: Array.isArray(product?.imageList) ? product.imageList : [],
          images: Array.isArray(product?.images) ? product.images : [],
          textAutor: product?.textAutor || "",
          seria: product?.seria || product?.series || "",
        },
      ];
    });
  };

  const saveItems = async (orderId) => {
    if (savingItems) return null;
    setSavingItems(true);

    try {
      const backend = "https://chas-maistriv.com.ua/api";

      const payload = {
        orderId,
        items: itemsDraft.map(({ __key, ...it }) => ({
          ...it,
          quantity: Math.max(1, Number(it.quantity || 1) || 1),
        })),
      };

      const resp = await fetch(`${backend}/admin/order/update-items`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await resp.json();

      if (!resp.ok) {
        throw new Error(json?.error || "Save failed");
      }

      await reloadOneOrder(orderId);

      cancelEditItems();
      return json;
    } finally {
      setSavingItems(false);
    }
  };

  return {
    orders,
    paged,
    expanded,
    toggleExpand,

    // filters
    sortDir,
    setSortDir,
    statusPin,
    setStatusPin,
    statusOnly,
    setStatusOnly,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    categoryFilter,
    setCategoryFilter,
    categorySort,
    setCategorySort,

    // paging
    page,
    pageSize,
    setPageSize,
    totalPages,
    pageClamped,
    goto,

    // status
    editingStatusId,
    statusDraft,
    setStatusDraft,
    beginEditStatus,
    saveStatus,
    cancelEditStatus,
    onStatusKey,

    // ttn
    editingTtnId,
    ttnDraft,
    setTtnDraft,
    beginEditTTN,
    saveTTN,
    saveTTNAndSetStatus,
    cancelEditTTN,
    onTtnKey,

    // items edit
    editingItemsId,
    itemsDraft,
    newPid,
    setNewPid,
    newQty,
    setNewQty,
    savingItems,
    beginEditItems,
    cancelEditItems,
    setItemQty,
    removeDraftItem,
    addDraftItem,
    saveItems,

    // meta
    isLoaded,
    STATUS_OPTIONS,
    ROLE_OPTIONS,
    ROLES,
  };
}
